import { css } from 'styled-components'

import abnamroSans700Woff from './abnamro-sans/ABNAMROSans-Bold_Web.woff'
import abnamroSans700Woff2 from './abnamro-sans/ABNAMROSans-Bold_Web.woff2'
import abnamroSans400Woff from './abnamro-sans/ABNAMROSans-Regular_Web.woff'
import abnamroSans400Woff2 from './abnamro-sans/ABNAMROSans-Regular_Web.woff2'
import abnamroSans600Woff from './abnamro-sans/ABNAMROSans-SemiBold_Web.woff'
import abnamroSans600Woff2 from './abnamro-sans/ABNAMROSans-SemiBold_Web.woff2'

export const fonts = css`
	/* ABN AMRO Sans regular - latin */
	@font-face {
		font-family: 'ABN AMRO Sans';
		font-style: normal;
		font-weight: 400;
		src:
			url(${abnamroSans400Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${abnamroSans400Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	/* ABN AMRO Sans semi-bold latin */
	@font-face {
		font-family: 'ABN AMRO Sans';
		font-style: normal;
		font-weight: 600;
		src:
			url(${abnamroSans600Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${abnamroSans600Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}

	/* ABN AMRO Sans bold - latin */
	@font-face {
		font-family: 'ABN AMRO Sans';
		font-style: normal;
		font-weight: 700;
		src:
			url(${abnamroSans700Woff2}) format('woff2'), /* Chrome 26+, Opera 23+, Firefox 39+ */
			url(${abnamroSans700Woff}) format('woff'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
	}
`
